export const LOGIN = "/login"
export const LOGOUT = "/logout"
export const FORGET_PWD = "/forget-password"
export const RESET_PWD = "/user/reset/:token"
export const TWO_FA = "/two-fa"
export const DASHBOARD = "/dashboard"

export const PROFILE = "/profile"
export const USER_ADMINISTRATION = "/user-administration"
export const PLATFORM_SETTINGS = "/platform-settings"

export const SETUP_LANDING_PAGE = "/landing-page-setup"
export const SETUP_LIST_SCREEN = "/list-screen-setup"
export const SETUP_CONTACT_US = "/contact-us-setup"
export const POPUP = "/pop-up"
export const EXPERIENCES = "/experiences"
export const CONTACTS = "/users"
export const COMMUNICATIONS = "/communications"
export const BOOKING_CALENDAR = "/booking-calendar"
export const EVENTS_CALENDAR = "/events-calendar"
export const ONBOARDING_FLOW = "/onboarding-flow"
export const ADD_NOTIFICATION = "/add-notification"
export const ADD_CUSTOM_EMAIL = "/add-custom-email"
export const EDIT_COMMUNICATION = "/communication/:id"

export const MANAGE_CATEGORIES = "/categories"
export const ADD_NEW_EXPERIENCE = "/add-event"
export const EDIT_EXPERIENCE = "/events/:vendor_id/:id"

export const DOMAINS = "/domains"
export const CREATE_DOMAIN = "/domains/create"
export const EDIT_DOMAIN = "/domains/:id"
export const BUSINESS_UNITS = "/business-units"

export const CLIENTS = "/vendors"
export const ADD_CLIENT = "/vendors/add"
export const EDIT_CLIENT = "/vendors/:id"
export const CLIENT_FEATURES = "/vendors/:id/features"

export const TAGS = "/tags"
export const CREATE_TAG = "/tags/create"
export const EDIT_TAG = "/tags/:id"

export const PLACES = "/places"

export const VISITORS = "/visitors"

export const ADD_ON_MODULES = "/add-on-modules"

export const ADD_PLACE = "/places/create"
export const EDIT_PLACE = "/places/:id"
export const VIEW_SURVEYS = "/places/:id/surveys"
export const CREATE_CATEGORY = "/categories/create"
export const EDIT_CATEGORY = "/categories/:id"

export const PRODUCTS_AND_SUBSCRIPTIONS = "/products-subscriptions"
export const ORDER_DETAILS = "/orders/:id"

export const SITE_USERS = "/site-users"
export const ADMIN_ROLES_MANAGEMENT = "/admin-roles"
export const PERMISSIONS_MANAGEMENT = "/permissions"
export const CANCELLED_BOOKING = "/checkout-cancelled-booking"
export const SUCCESS_BOOKING = "/checkout-success-booking/:id"

export const CODES = "/codes"
export const GENERATE_CODES = "/codes/generate"

export const TICKETPEAK = "/ticketing"

export const EVENT_REPORTS = "/event-reports/:id"
export const POLL_REPORTS = "/reports/:event_id/polls/:feature_id"
export const SURVEY_REPORTS = "/reports/:event_id/surveys/:feature_id"
export const POLL_LIST = "/reports/:event_id/polls"
export const SURVEY_LIST = "/reports/:event_id/surveys"
export const FORM_BUILDER_LIST = "/reports/:event_id/form-builders"
export const QUESTIONNAIRE_LIST = "/reports/:event_id/questionnaires"
export const TRIVIA_LIST = "/reports/:event_id/trivias"
export const EVENT_INFO_LIST = "/reports/:event_id/event-info"
export const WEB_LINK_LIST = "/reports/:event_id/web-links"
export const WEB_LINK_REPORTS = "/reports/:event_id/web-links/:feature_id"
export const FORM_BUILDER_REPORTS =
  "/reports/:event_id/form-builders/:feature_id"
export const QUESTIONNAIRE_REPORTS =
  "/reports/:event_id/questionnaires/:feature_id"
export const TRIVIA_REPORTS = "/reports/:event_id/trivias/:feature_id"
export const BOOKING_PAYMENT_REPORTS = "/booking-payment-reports"
export const FORM_PAYMENT_REPORTS = "/form-payment-reports"
export const EVENT_INFO_REPORTS = "/reports/:event_id/event-info/:feature_id"
export const BASIC_CONTENT_LIST = "/reports/:event_id/basic-content"
export const BASIC_CONTENT_REPORTS =
  "/reports/:event_id/basic-content/:feature_id"
export const DOCUMENT_LIST = "/reports/:event_id/documents"
export const DOCUMENT_REPORTS = "/reports/:event_id/documents/:feature_id"
export const COMMENT_BOARD_LIST = "/reports/:event_id/comment-board"
export const COMMENT_BOARD_REPORTS =
  "/reports/:event_id/comment-board/:feature_id"
export const COUNTDOWN_CLOCK_LIST = "/reports/:event_id/countdown-clocks"
export const COUNTDOWN_CLOCK_REPORTS =
  "/reports/:event_id/countdown-clocks/:feature_id"
export const MEDIA_GALLERY_LIST = "/reports/:event_id/media-gallery"
export const MEDIA_GALLERY_REPORTS =
  "/reports/:event_id/media-gallery/:feature_id"
export const CAMERA_REPORTS = "/reports/:event_id/camera"
export const LEADERBOARD_REPORTS = "/reports/:event_id/leaderboard"
export const PRIVATE_MESSAGE_REPORTS = "/reports/:event_id/private-message"
export const REFER_FRIEND_REPORTS = "/reports/:event_id/refer-friend"
export const ATTENDEE_LIST_REPORTS = "/reports/:event_id/attendee-list"
export const CALENDAR_REPORTS = "/reports/:event_id/calendars"
export const LIST_REPORTS = "/reports/:event_id/lists/:feature_id"
export const LIST_OF_LISTS = "/reports/:event_id/lists"
export const LIST_ITEM_REPORTS = "/reports/:event_id/list-items/:feature_id"

export const BOOKING_CALENDAR_REPORTS = `/reports/:event_id/bookings/calendars`
export const SUB_CALENDAR_REPORTS = `/reports/:event_id/bookings/:calendar_id/sub-calendars`
export const USER_BOOKING_REPORTS = `/reports/:event_id/bookings/users`
export const BOOKING_REPORTS = "/reports/:event_id/bookings"

export const FLAGGED_CONTENT = "/events/:vendor_id/:event_id/flagged"

export const CHECKOUT_SUCCESS = "/checkout-success"
export const IFO_SUBSCRIPTION = "/ifo_subscription/:identifier"
export const HARVARD_SUBSCRIPTION = "/harvard/:identifier"
export const DEFAULT_FORM_URL = "/form/:identifier"

export const NEWS_FEED = "/news-feed"
export const INBOX_INB = "/inbox_inb"
export const COMMENT_BOARDS = "/comment_boards"
export const AXISCARE = "/axiscare"